'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Form = function Form(_ref) {
  var children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      onSubmit = _ref.onSubmit,
      onReset = _ref.onReset,
      inline = _ref.inline;

  var formClassNames = (0, _classnames2.default)('luna-form', className, {
    'luna-form--inline': inline
  });

  var handleChange = function handleChange(e) {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(e);
    }
  };

  return _react2.default.createElement(
    'form',
    { className: formClassNames, onSubmit: handleChange, onReset: onReset, id: id },
    children
  );
};

Form.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  onSubmit: _propTypes2.default.func,
  onReset: _propTypes2.default.func
};

exports.default = Form;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Form/Form.js